import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[tnghTimePicker]'
})
export class TimePickerDirective {
  constructor(private el: ElementRef<HTMLInputElement>) { }

  private get isTimeInput() {
    return this.el.nativeElement.type === 'time';
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.isTimeInput) {
      event.preventDefault(); // block typing
    }
  }

  @HostListener('click')
  onClick() {
    if (this.isTimeInput) {
      const input = this.el.nativeElement as any;
      if (input.showPicker) {
        input.showPicker();
      }
    }
  }
}
